import axios from 'axios'

function regAnalyticReq({
  counterType,
  eventType,
  projectId,
  offerType = null,
  offerId = null,
  offerLink = null,
}) {
  return axios.post(
    'https://europe-west3-isee-iterra.cloudfunctions.net/regApiCounter',
    {
      counterType,
      date: new Date(),
      eventType,
      projectId,
      offerType,
      offerId,
      offerLink,
    },
  )
}

export default regAnalyticReq
